import { useEffect, useRef, useState } from "react"

interface Props {
  /** How frequenty the current time should be polled */
  interval?: number
}

/** Default every 10 seconds */
const default_interval = 1000 * 10

/** Returns the current datetime as a string */
const useCurrentTime = (props?: Props): string => {
  const [date_string, setDateString] = useState(new Date().toISOString())
  const interval = useRef<NodeJS.Timer | undefined>()

  useEffect(() => {
    if (interval.current) {
      clearInterval(interval.current)
    }

    interval.current = setInterval(() => {
      setDateString(new Date().toISOString())
    }, props?.interval || default_interval)

    return () => {
      if (interval.current) {
        clearInterval(interval.current)
      }
    }
  }, [props?.interval])

  return date_string
}

export default useCurrentTime
